
import { createServer } from 'miragejs'
import appConfig from 'configs/app.config'  

import { signInUserData } from './data/authData'

import { authFakeApi, salesFakeApi } from './fakeApi'

import { productsData, ordersData, orderDetailsData, studentRecordData } from './data/salesData'

const { apiPrefix } = appConfig

export default function mockServer({ environment = 'test' }) {
    return createServer({
        environment,
        seeds(server) {
			server.db.loadData({
				signInUserData,
                studentRecordData
			})
		},
        routes() {
            this.urlPrefix = ''
            this.namespace = ''
            this.passthrough(request => {
                let isExternal = request.url.startsWith('http')
                return isExternal
            })
            this.passthrough()
            
            
            authFakeApi(this, apiPrefix)
            salesFakeApi(this, apiPrefix)
        },
    })
}